import type { FaireProductEntity } from "../../entity_types/product";

export const p_gv2twn33tr: FaireProductEntity = {
  token: "p_gv2twn33tr",
  type: "product",
  name: "24 Funny Greeting Cards Set with Envelopes - 24 Designs",
  brandName: "T Marie",
  imageUrl:
    "https://cdn.faire.com/fastly/2702c32171f28661189d6980f9b487928033e907fd7bc9eaf3b2df8574d43e9c.jpeg",
  priceDollars: 6.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0b95bd56d512e71d61730d2d399d0f2a1688b0ca8423c84127b9275105421476.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
